import React from 'react'
import { Link } from 'react-router-dom'

const cards = [
  { to: '/ratings/admin/certification', title: 'Tournament certification', desc: 'Manual certification and tier assignment.' },
  { to: '/ratings/admin/recalculate', title: 'Recalculate', desc: 'Queue recalculation jobs from tournament point.' },
  { to: '/ratings/admin/results', title: 'Manual results JSON', desc: 'Submit tournament results manually as JSON.' },
]

const RatingAdminHome: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 pt-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-4">
        <h1 className="text-2xl font-black text-slate-900">Reytinq İdarəetmə Paneli</h1>

        <div className="bg-white dark:bg-gray-900 rounded-2xl border border-slate-100 dark:border-gray-800 shadow-sm p-4 text-sm text-slate-700 space-y-1">
          <p>
            UI entry for excel import: <Link className="text-blue-700 hover:text-blue-900 dark:text-indigo-300" to="/organizer">Organizer portal</Link>
          </p>
          <p>
            Appeals moved to profile: <Link className="text-blue-700 hover:text-blue-900 dark:text-indigo-300" to="/profile/appeals">/profile/appeals</Link>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {cards.map((c) => (
 <Link key={c.to} to={c.to} className="bg-white dark:bg-gray-900 rounded-2xl border border-slate-100 dark:border-gray-800 shadow-sm p-4 hover:shadow-md transition">
              <p className="font-semibold text-slate-900">{c.title}</p>
              <p className="text-sm text-slate-500 dark:text-gray-400 mt-1">{c.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RatingAdminHome
